<template>
  <div>
    <PageAllow controller="Requisitions" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('Requisition.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>

        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('Requisitions', 'batchApprove')"
              small
              color="warning"
              class="ms-1 float-end"
              @click="batchApproveDialog = true"
            >
              <v-icon x-small class="pe-1">fa-align-justify</v-icon>
              {{ $t("Requisition.actions.batchApprove") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Requisitions', 'getPricingMaterials')"
              small
              color="primary"
              dark
              class="ms-1 float-end"
              href="/#/requisitions/batch-pricing"
            >
              {{ $t("Requisition.batchPricing") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Requisitions', 'getOutPricingMaterials')"
              small
              color="primary"
              href="/#/requisitions/out-batch-pricing"
              class="ms-1"
            >
              {{ $t("Requisition.outBatchPricing") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Requisitions', 'addViews')"
              small
              color="primary"
              dark
              class="ms-1 float-end"
              href="/#/requisitions/auto-requisition"
            >
              {{ $t("Requisition.autoBtn") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Requisitions', 'add')"
              small
              color="primary"
              href="/#/requisitions/new"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("Requisition.RegularRequisition")]) }}
            </v-btn>

<!--            <v-menu-->
<!--              v-model="addBtnMenu"-->
<!--              open-on-hover-->
<!--              close-on-click-->
<!--              close-on-content-click-->
<!--              offset-y-->
<!--              v-if="$permission.permissionAllow('Requisitions', 'add')"-->
<!--            >-->
<!--              <template v-slot:activator="{ on, attrs }">-->
<!--                <v-btn-->
<!--                  small-->
<!--                  color="primary"-->
<!--                  dark-->
<!--                  v-bind="attrs"-->
<!--                  v-on="on"-->
<!--                  class="ms-1 float-end"-->
<!--                >-->
<!--                  <v-icon x-small class="pe-1">fa-plus</v-icon>-->
<!--                  {{ $t("CRUD.newInfo", [$t("Requisition.ObjectName")]) }}-->
<!--                  <v-icon x-small class="ps-1">-->
<!--                    {{ addBtnMenu ? "fa-caret-up" : "fa-caret-down" }}-->
<!--                  </v-icon>-->
<!--                </v-btn>-->
<!--              </template>-->
<!--              <v-list dense>-->
<!--                <v-list-item href="/#/requisitions/new">-->
<!--                  <v-list-item-title>-->
<!--                    {{-->
<!--                      $t("CRUD.newInfo", [$t("Requisition.RegularRequisition")])-->
<!--                    }}-->
<!--                  </v-list-item-title>-->
<!--                </v-list-item>-->
<!--                <v-list-item href="/#/requisitions/premuim-new">-->
<!--                  <v-list-item-title>-->
<!--                    {{-->
<!--                      $t("CRUD.newInfo", [$t("Requisition.PremuimRequisition")])-->
<!--                    }}-->
<!--                  </v-list-item-title>-->
<!--                </v-list-item>-->
<!--              </v-list>-->
<!--            </v-menu>-->
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="requisition_code"
                  v-model="options.requisition_code"
                  @text="requisitionCodeKeyword = $event"
                  :label="$t('Requisition.Fields.requisition_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stockInSelected"
                  :label="$t('Requisition.stockOutSearcher')"
                  :stock-types="[0]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stockOutSelected"
                  :label="$t('Requisition.stockInSearcher')"
                  :stock-types="[0]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  color="primary"
                  hide-no-data
                  v-model="typesSelected"
                  chips
                  multiple
                  clearable
                  deletable-chips
                  small-chips
                  :items="$consts.requisition.types"
                  item-text="text"
                  item-value="value"
                  :label="$t('Requisition.types.title')"
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('Requisition.status.title')"
                  :items="$consts.requisition.status"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="(settings && settings.requisition_express_display) ? requisitionItems : requisitions"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.requisition_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.requisition_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip
              small
              label
              :color="item.type | requisitionTypesColor"
              :text-color="item.type | requisitionTypesTextColor"
            >
              {{ item.type | requisitionTypesText }}
            </v-chip>
            <br />
            <v-chip v-if="item.cancel_flg" x-small label outlined color="danger"
              >{{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | requisitionStatusColor"
              :text-color="item.status | requisitionStatusTextColor"
            >
              {{ item.status | requisitionStatusText }}
            </v-chip>
            <br />
            <v-chip v-if="item.cancel_flg" x-small label outlined color="danger"
              >{{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.express_price="{ item }">
            <span
              v-if="item.edit_express"
            >
              <v-text-field
                v-model="item.express_price"
                :placeholder="
                  String(
                    $numberFormatter.formatTwoDot(
                      item.express_price,
                      2
                    )
                  )
                "
                single-line
                dense
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.express_price =
                    item.express_price == ''
                      ? item.express_price
                        : $numberFormatter.formatMoneyFloor(
                          item.express_price
                        )
                "
                style="max-width: 80px; margin-left: auto"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="item.edit_express"
                    x-small
                    @click.stop="saveExpress(item)"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </span>
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.express_price | formatMoneyFloor }}
              <v-icon
                v-if="
                  !item.edit_express &&
                  (item.status == 1 || item.status == 2) &&
                  settings &&
                  settings.requisition_express_price == 1
                "
                x-small
                color="primary"
                class=""
                style="display: inline-block"
                @click.stop="setEditExpressFlg(item)"
              >fa-pencil-alt
              </v-icon>
            </span>

          </template>
          <template v-slot:item.actions="{ item }">
            <RequisitionActions
              :requisition="item"
              showView
              showExport
              :showEdit="item.actions.edit"
              :showLogistic="$permission.permissionAllow('Requisitions', 'editLogistics')"
              :showApprove="item.actions.approve"
              :showCancel="item.actions.cancel"
              :showStockOut="item.actions.out"
              :showStockIn="item.actions.in"
              :showReturn="item.actions.return"
              @done="getRequisitionsFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <!-- 批量通过 -->
    <DialogAlert
      v-model="batchApproveDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Requisition.Messages.batchApproveAlert')"
      persistent
      useConfirm
      @confirm="
        batchApproveDialog = false;
        batchApproveInfoDialog = true;
        batchApprove(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchApproveInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchApproveInfo"
      persistent
      :closable="errorCount > 0"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import RequisitionActions from "./plugins/Actions";
import Requisitions from "@/api/requisitions";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DialogAlert from "@/components/plugins/DialogAlert.vue";
import BatchOperationInfoAlert from "@/components/orders/plugins/BatchOperationInfoAlert.vue";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  status: [1, 2, 3],
  types: [],
  cancel_flgs: [0],
  stock_from_id: 0,
  stock_to_id: 0,
  requisition_code: "",
};

export default {
  components: {
    BatchOperationInfoAlert,
    DialogAlert,
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherStock,
    SearcherStatus,
    SearcherCancelFlgs,
    RequisitionActions,
    SearcherKeyword,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.requisitions"),
        disabled: true,
        href: "/requisitions",
      },
    ],

    headers() {
      let headers = [
        {
          text:
            i18n.t("Requisition.Fields.requisition_code") +
            " / " +
            i18n.t("Requisition.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "requisition_code",
        },
        {
          text: i18n.t("Requisition.Fields.stock_requisition_out"),
          align: "start",
          sortable: false,
          value: "from_stock.name",
        },
        {
          text: i18n.t("Requisition.Fields.stock_requisition_in"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "to_stock.name",
        },
        {
          text: i18n.t("Requisition.Fields.type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("Requisition.Fields.material_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "details_count",
        },
      ];
      if (this.settings && this.settings.requisition_express_display) {
        headers.push(
          {
            text: i18n.t("Requisition.Fields.express_price"),
            align: "center",
            class: "text-no-wrap",
            sortable: false,
            value: "express_price",
          }
        )
      }
      headers.push(
        {
          text: i18n.t("Requisition.Fields.applicant_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "applier_name",
        },
        {
          text: i18n.t("Requisition.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      )
      return headers
    },
    requisitionItems() {
      return this.requisitions.map((requisition) => {
        if (this.editExpressData && requisition.id == this.editExpressData.id) {
          requisition.edit_express = 1;
        }else {
          requisition.edit_express = 0;
        }
        return requisition
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    addBtnMenu: false,
    requisitions: [],
    options: JSON.parse(
      sessionStorage.getItem("requisitions-options")
        ? sessionStorage.getItem("requisitions-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    requisitionKeyWord: "",
    stockOutSelected: null,
    typesSelected: null,
    stockInSelected: null,
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    errorCount: 0,
    successCount: 0,
    approvable: [],
    approvableLength: 0,
    alreadyApprovedLength: 0,
    errorRequisitionId: [],
    batchApproveDialog: false,
    batchApproveInfoDialog: false,
    batchApproveInfo: i18n.t("Requisition.Messages.batchApproveInfo", [0, 0]),
    batchApproveErrorDialog: false,
    batchApproveErrorData: [],
    editExpressData: null,

  }),

  mounted() {
    this.$commonUtils
      .loadOptions("requisitions", ["stockOutSelected", "stockInSelected", "typesSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockOutSelected":
                this.stockOutSelected = selected.value;
                break;
              case "stockInSelected":
                this.stockInSelected = selected.value;
                break;
              case "typesSelected":
                this.typesSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      // this.getRequisitionsFromAPI();
      this.options = Object.assign({}, this.options, {
        requisition_code: this.requisitionCodeKeyword,
      });
    },
    resetSearch() {
      this.stockOutSelected = null;
      this.typesSelected = null;
      this.stockInSelected = null;
      this.editExpressData = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.requisition_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    getRequisitionsFromAPI() {
      this.editExpressData = null;
      var options = JSON.parse(JSON.stringify(this.options));
      Requisitions.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.requisitions = response.data.requisitions;
            this.paging = response.data.paging;


            let approvable = [];
            this.requisitions.forEach((requisition) => {
              //取可审批的单子
              if (requisition.actions.approve) {
                approvable.push(requisition);
              }
            });
            this.approvable = approvable;
            this.approvableLength = approvable.length;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    batchApprove(options) {
      if (this.errorRequisitionId.length) {
        options.no_requisition_ids = this.errorRequisitionId;
      }
      Requisitions.batchApprove(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.requisition_flg) {
                ++this.successCount;
              } else {
                this.errorRequisitionId.push(response.data.requisition_id);
                ++this.errorCount;
                // this.batchApproveErrorData.push(response.data.data[0]);
                // this.batchApproveErrorDialog = true;
              }
            } else {
              if (response.data.error.code != "ERR333") {
                this.errorRequisitionId.push(response.data.requisition_id);
                ++this.errorCount;
                // if (response.data.error.code == "ERR668") {
                //   this.batchApproveErrorData.push(response.data.data[0]);
                //   this.batchApproveErrorDialog = true;
                // }
              } else {
                this.getRequisitionsFromAPI();
                options = null;
                this.errorRequisitionId = [];
                this.successCount = 0;
                this.errorCount = 0;
                this.alreadyApprovedLength = 0;
                this.batchApproveInfoDialog = false;
              }
            }
            //去除本次审批的单子
            this.approvable.splice(0, 1);
            //实时计数
            this.batchApproveInfo = i18n.t("Requisition.Messages.batchApproveInfo", [
              this.successCount,
              this.errorCount,
            ]);
            ++this.alreadyApprovedLength; //计已审批的单子总数
            if (
                response.data.status.isOK() ||
                response.data.error.code != "ERR333"
            ) {
              //回调
              this.batchApprove(options);
            }
          }.bind(this)
      );
    },
    setEditExpressFlg(data) {
      if (this.editExpressData && this.editExpressData.id != data.id) {
        // 未保存且切换待修改单据时
        this.requisitions = this.requisitions.map((requisition) => {
          if (requisition.id == this.editExpressData.id) {
            requisition.express_price = this.editExpressData.express_price;
          }
          return requisition;
        })
      }
      this.editExpressData = Object.assign({}, data);
    },
    saveExpress(data) {
      Requisitions.saveExpress(data.id, {
        id: data.id,
        express_price: data.express_price,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getRequisitionsFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getRequisitionsFromAPI();
        sessionStorage.setItem(
          "requisitions-options",
          JSON.stringify(this.options)
        );
      },
    },
    stockOutSelected: {
      handler() {
        this.options.stock_to_id = this.stockOutSelected
          ? this.stockOutSelected.id
          : 0;
        sessionStorage.setItem(
          "requisitions-stockOutSelected",
          JSON.stringify(this.stockOutSelected)
        );
      },
    },
    typesSelected: {
      handler() {
        this.options.types = this.typesSelected
            ? this.typesSelected.map((e) => {
              return e.value;
            })
            : [];
        sessionStorage.setItem(
          "requisitions-typesSelected",
          JSON.stringify(this.typesSelected)
        )
      }
    },
    stockInSelected: {
      handler() {
        this.options.stock_from_id = this.stockInSelected
          ? this.stockInSelected.id
          : 0;
        sessionStorage.setItem(
          "requisitions-stockInSelected",
          JSON.stringify(this.stockInSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>